<template>
  <div>

    <div>
      <button 
        @click="render"
        class="h-12 px-6 m-2 text-lg text-indigo-100 transition-colors duration-150 bg-indigo-700 rounded-lg focus:shadow-outline hover:bg-indigo-800"
        >Render</button>
    </div>

    <div>
      <div id="container" style="width: 500px; height: 500px;"></div>
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useTemplateStore } from '~/store/template'
import mockDataWish from '~/public/mockDataWish'

definePageMeta({
  layout: 'clean'
})

export default defineComponent({
  setup () {

    const templateStore = useTemplateStore()


    const templateId = 'premiumMock0002'
    onMounted(() => {
      templateStore.addScriptByTemplateId(templateId)
      
    })


    const render = () => {
      const data = {
        ...mockDataWish,
        wish: {
          ...mockDataWish.wish,
          templateId: templateId
        }
      }
        templateStore.renderTemplatePreview(data)


      setTimeout(() => {
        templateStore.renderTemplatePreview(data)
      }, 1000);
    }
    

    return {
      render
    }
  }
})
</script>

<style scoped>

</style>public/mockDataWish